import { Infer, string, type } from "superstruct";

export const OfferErrorStruct = type({
  type: string(),
  title: string(),
  message: string(),
});

export type OfferErrorType = Infer<typeof OfferErrorStruct>;
